import React, { FC } from 'react'
import { animated } from 'react-spring'
import styled from 'styled-components'

import colors from '../colors'
import images from '../images'
import { useFadeIn } from '../utils/hooks'

const Container = styled(animated.div)`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const Top = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
const ImageContainer = styled.div`
  position: relative;
`
const Image = styled.img.attrs({ src: images.intro })`
  width: 279px;
  height: 308px;
`
const CoinviewLogo = styled.img.attrs({ src: images.coinview })`
  width: 84px;
  height: 24px;
  position: absolute;
  right: -24px;
  top: 0;
`
const Text = styled.div`
  max-width: 320px;
  padding: 16px;
  margin: 16px 32px 0;
  color: ${colors.blue};
  background-color: white;
  border-radius: 8px;
  font-size: 16px;
`
const Button = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 320px;
  height: 48px;
  margin: 12px 16px 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  cursor: pointer;
  box-sizing: border-box;
  color: ${colors.blue};
  background-color: white;
  border-radius: 24px;
  border: 1px solid ${colors.blue};
  box-shadow: 0px 4px 0px 0px ${colors.blue};

  &:hover {
    color: white;
    background: ${colors.blue};
    box-shadow: none;
  }
`
const ButtonText = styled.div`
  color: inherit;
  font-size: 16px;
`

interface Props {
  onPressStart: () => void
}

const Intro: FC<Props> = ({ onPressStart }) => {
  const anim = useFadeIn()

  return (
    <Container style={anim}>
      <Top>
        <ImageContainer>
          <Image src={images.intro} />
          <CoinviewLogo />
        </ImageContainer>
        <Text>
          「これから仮想通貨を始めたい」「最適な取引所を選びなおしたい」そんな方の為に、仮想通貨アプリ・コイン相場が作った診断ツールです。いくつかの質問に答えるだけで、あなたにぴったりの取引所を診断します。
        </Text>
      </Top>
      <Button onClick={onPressStart}>
        <ButtonText>スタート</ButtonText>
      </Button>
    </Container>
  )
}

export default Intro
